// @flow

import React, { useEffect, useState } from "react";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { View, Button, FormGroup, Form, Label, ComboBox } from "@components";
import { connect } from "react-redux";
import actionCreators from "@modules/service/actionCreator";
import type { State } from "@store/reducers";
import * as serviceSelectors from "@modules/service/selectors";
import type { ReferralProcessesData } from "@modules/service/reducer/referrals/types";

type PropsFromState = $Exact<{
  suppliersData: ReferralProcessesData,
}>;

type PropsFromDispatch = $Exact<{
  getSuppliersList: typeof actionCreators.GetReferralList,
}>;

type Props = $Exact<{
  clientId: number,
  handleSubmit: Function,
  handleChange: Function,
  onChange: Function,
  data: Object,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

function ReferralTrackerFilter(props: Props) {
  const { clientId, t, suppliersData } = props;
  const [suppliersList, setSuppliersList] = useState([
    {
      label: t("ALL"),
      value: null,
    },
  ]);

  useEffect(() => {
    props.getSuppliersList({
      clientId,
      isActive: true,
    });
  }, [clientId]);

  useEffect(() => {
    const list = (suppliersData?.content || []).map(item => ({
      value: item.id,
      label: item.content.name,
    }));

    if (!!list.length) {
      setSuppliersList([...suppliersList, ...list]);
    }
  }, [suppliersData]);

  const handleOnChange = (field, value) => {
    const filters = { ...props.data, [field]: value };
    props.handleChange(filters);
  };

  const submitForm = e => {
    e.preventDefault();
    props.handleSubmit();
  };

  return (
    <Form onSubmit={submitForm}>
      <View direction="row" gap={4} justifyContent="start" alignItems="flex-end">
        <FormGroup className="min-width-160-px">
          <Label
            for={"referralProcessId"}
            className="d-flex justify-content-between align-items-center pr-1"
          >
            {t("SUPPLIER")}
          </Label>
          <ComboBox
            value={props.data?.referralProcessId || null}
            onChange={value => handleOnChange("referralProcessId", value || null)}
            options={suppliersList}
            withoutEmptyOption
          />
        </FormGroup>

        <FormGroup className="min-width-160-px">
          <Label
            for={"referralType"}
            className="d-flex justify-content-between align-items-center pr-1"
          >
            {t("REFERRAL_TYPE")}
          </Label>
          <ComboBox
            value={props.data?.referralType || null}
            onChange={value => handleOnChange("referralType", value || null)}
            options={[
              {
                label: t("ALL"),
                value: null,
              },
              {
                label: t("EMPLOYEE_REFERRAL"),
                value: "EMPLOYEE_REFERRAL",
              },
              {
                label: t("MANAGER_REFERRAL"),
                value: "MANAGER_REFERRAL",
              },
              {
                label: t("MANUAL_REFERRAL"),
                value: "MANUAL_REFERRAL",
              },
            ]}
            withoutEmptyOption
          />
        </FormGroup>
        <FormGroup>
          <Button materialIcon="replay_circle_filled" type="submit">
            {t("SUBMIT")}
          </Button>
        </FormGroup>
      </View>
    </Form>
  );
}

const mapStateToProps = (state: State): PropsFromState => ({
  suppliersData: serviceSelectors.referralProcessData(state),
});
const mapDispatchToProps: PropsFromDispatch = {
  getSuppliersList: actionCreators.GetReferralList,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(ReferralTrackerFilter);
